module.exports = __webpack_public_path__ + "static/avatar_qz-bab42f2a1fc1dbac00307d4c2c595ff2.png";